// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"ff0eb24e","305":"5a0ea80c","308":"28080b2e","316":"098039d8","491":"9201aef5","670":"ba0a8370","787":"cb623dd8"}[chunkId] + ".chunk.js";
};